import styled from "styled-components";

const AlertBox = styled.div`
    padding: 1em;
    color: #a94442;
    background-color: #f2dede;
    border: 0px;
    margin-bottom: 0.5rem;
    border-radius: 4px;
    font-size: 14px;
    text-align: left;
    line-height: 1.42857143;
`;

// Errors are announced by screen readers as soon as they appear (RGAA 7.5.2).
export const Alert = styled(AlertBox).attrs({ role: "alert" })``;

// To display in a role="status" region that is always in the page, so the
// message is announced when it appears (RGAA 7.5.1).
export const AlertSuccess = styled(AlertBox)`
    color: #3c763d;
    background-color: #dff0d8;
`;
